import { render } from "./EditRecord.vue?vue&type=template&id=4d6ddf16&scoped=true"
import script from "./EditRecord.vue?vue&type=script&lang=js"
export * from "./EditRecord.vue?vue&type=script&lang=js"

import "./EditRecord.vue?vue&type=style&index=0&id=4d6ddf16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6ddf16"]])

export default __exports__